<template>
    <div :class="$style.wrapper">
        <div :class="$style.header">
            <span>商品</span>
            <span>单价</span>
            <span>数量</span>
            <span>实付金额</span>
            <span>订单状态</span>
            <!--<span >利润</span>-->
            <span>操作</span>
        </div>
        <div v-if="orderList.length === 0" style="text-align: center">暂无数据</div>
        <div v-else>
            <Order v-for="item in orderList" :key="item.id" :order="item" :getOrderList="getOrderList"></Order>
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="currPage"
                :page-count="totalPage"
                :getOrderList="getOrderList"
                @current-change="handlePageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import Order from './Order';
    import Vue from 'vue';

    Vue.component('Order', Order);
    export default {
        props: ['orderList', 'totalPage', 'getOrderList', 'currPage'],
        data () {
            return {};
        },
        methods: {
            handlePageChange(val) {
                this.getOrderList({page: val});
            }
        },
    };
</script>

<style lang="less" module>
    .wrapper {
        .header {
            height: 40px;
            margin-bottom: 15px;
            background: #f2f4f5;
            line-height: 40px;
            font-size: 14px;
            color: #636975;
            &>span{
                display: inline-block;
                text-align: center;
            }
            &>span:nth-child(1) {
                width:21%;
            }
            &>span:nth-child(2) {
                width: 5%;
            }
            &>span:nth-child(3) {
                width: 3%;
            }
            &>span:nth-child(4) {
                width: 38%;
            }
            &>span:nth-child(5) {
                width: 6.5%;
            }
            &>span:nth-child(6) {
                width: 25%;
            }
            &>span:nth-child(7) {
                width:7%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/Content.vue